// Helpers for turning the api's version-prefixed DTO paths into absolute URLs the
// browser can load. `origin` is the api origin (no version) — each FE app binds
// its own, keeping the join logic in one place.

/**
 * Resolve a DTO `avatarUrl` (a version-prefixed api path, or null) to an absolute
 * `<img>` src on the api origin. Undefined when the user has no avatar, so callers
 * fall back to initials. The path 302-redirects to a fresh presigned R2 URL each
 * load.
 */
export function avatarSrc(
	origin: string,
	avatarUrl: string | null | undefined,
): string | undefined {
	return avatarUrl ? `${origin}${avatarUrl}` : undefined;
}
